import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BancoDeDadosService {
  public baseUrlservice: string

  constructor(private http: HttpClient) {
    this.baseUrlservice = environment.URL_API + '/selecionar_banco';
  }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: JSON.parse(sessionStorage.getItem('currentUser')).token
    })
  };

  alterarBanco(bancoMarca: any) {
    const body = `?bancoMarca=${bancoMarca}`;
    return this.http.get(this.baseUrlservice + body, this.httpOptions).toPromise();
  }

  listarBancos() {
    return this.http.get(this.baseUrlservice + '/bancos', this.httpOptions).toPromise();
  }

}
